// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edititem-color-payment {
    background-color: #cfcfcf !important;
    border-radius: 0;
}

.edititem-color-payment a {
    color: #000000 !important;
}

.payhere-config-link {
    text-decoration: none;
    transition: all 0.3s ease;
}

.payhere-config-link:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.payment-mode-custom-select {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
}

.currency-custom-select {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
}

.payhere-field-wrapper {
    margin-bottom: 1rem;
}

.payhere-merchant-section {
    background-color: #f8f9fa;
    border-radius: 0.5rem;
    padding: 1.5rem;
    border: 1px solid #e9ecef;
}

.payhere-url-section {
    background-color: #fff;
    border-radius: 0.5rem;
    padding: 1.5rem;
    border: 1px solid #e9ecef;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Settings/PaymentSetting_All/PayHere.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,yBAAyB;AAC7B","sourcesContent":[".edititem-color-payment {\n    background-color: #cfcfcf !important;\n    border-radius: 0;\n}\n\n.edititem-color-payment a {\n    color: #000000 !important;\n}\n\n.payhere-config-link {\n    text-decoration: none;\n    transition: all 0.3s ease;\n}\n\n.payhere-config-link:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.payment-mode-custom-select {\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 0.375rem;\n}\n\n.currency-custom-select {\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 0.375rem;\n}\n\n.payhere-field-wrapper {\n    margin-bottom: 1rem;\n}\n\n.payhere-merchant-section {\n    background-color: #f8f9fa;\n    border-radius: 0.5rem;\n    padding: 1.5rem;\n    border: 1px solid #e9ecef;\n}\n\n.payhere-url-section {\n    background-color: #fff;\n    border-radius: 0.5rem;\n    padding: 1.5rem;\n    border: 1px solid #e9ecef;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
